var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"x-like"},[_c('section',{staticClass:"like line",on:{"click":_vm.handleLike}},[(!_vm.likeState)?_c('img',{staticClass:"icon",attrs:{"src":"https://assets.aiyaopai.com/like.png"}}):_c('img',{staticClass:"icon",attrs:{"src":"https://assets.aiyaopai.com/liked.png"}}),_vm._v(" "+_vm._s(_vm.num)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }